import { LinkButton, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DailyrentBanner.css';

export interface IDailyrentBannerProps {
  url: string;
  onClick(): void;
}

export function DailyrentBanner(props: IDailyrentBannerProps) {
  return (
    <div className={styles['banner']} data-name="DailyrentBanner">
      <div className={styles['info']}>
        <div className={styles['header']}>
          <UIHeading1 color="white_100">Отпуск не за горами</UIHeading1>
        </div>
        <div className={styles['text']}>
          <UIText1 color="white_100">Направления для активного отдыха в&nbsp;России</UIText1>
        </div>
        <div className={styles['button']}>
          <LinkButton theme="fill_white_primary" size="L" href={props.url} onClick={props.onClick}>
            Посмотреть
          </LinkButton>
        </div>
      </div>
    </div>
  );
}
